// extracted by mini-css-extract-plugin
export var card = "frontend-module--card--KRr7J";
export var container = "frontend-module--container--Gw0pg";
export var divider = "frontend-module--divider--BdkcN";
export var info = "frontend-module--info--btyW2";
export var link = "frontend-module--link--Gs6YP";
export var row = "frontend-module--row--ecaMg";
export var typography = "frontend-module--typography--OVrlP";
export var typographyCard = "frontend-module--typographyCard--F3vAJ";
export var view = "frontend-module--view--kFtHv";